import { toast } from "react-toastify";
import config from "./../config";

const milliSecondToHour = 1000 * 60 * 60;

const isCacheValid = function (response, cacheExpirationHours) {
    if (!response) return false;
    var fetched = response.headers.get('sw-fetched-on');
    if (fetched && (parseFloat(fetched) + (milliSecondToHour * cacheExpirationHours)) > new Date().getTime()) return true;
    return false;
};

const getResponseFrom = {
    /* ---{ Get response through caching, if it does not exist then fetch and cache the response }--- */
    Cache: function (bearerToken, apiUrl, cacheExpirationHours) {
        return new Promise(async (resolve, reject) => {
            let cache = await caches.open(config.app.cacheName),
                response = await cache.match(apiUrl);

            if (response && isCacheValid(response, cacheExpirationHours)) {
                resolve(response);
            } else {
                let headers = new Headers();

                headers.set("Authorization", `Bearer ${bearerToken}`);

                response = await fetch(apiUrl, { headers }).catch(error => console.log(error.message));
                if(!response) {
                    response = {
                        "ok": false,
                        "status": 503,
                        "statusText": "Service Unavailable",
                        "url": apiUrl
                    }
                    reject(response);
                }
                else if (!(response.status >= 200 && response.status < 500)) {
                    reject(`Request to [...] failed: ${response.status} - ${response.statusText}`);
                }
                //Only cache result if status is valid
                else if (response.status >= 200 && response.status < 400) {
                    var responseCopy = response.clone()
                    headers = new Headers(responseCopy.headers);
                    headers.append('sw-fetched-on', new Date().getTime())
                    cache.put(apiUrl, new Response(responseCopy.body, {
                        status: responseCopy.status,
                        statusText: responseCopy.statusText,
                        type: responseCopy.type,
                        url: responseCopy.url,
                        headers: headers
                    }));

                    resolve(response);
                }
                else { //Error code >= 400 && < 500
                    resolve(response);
                }
            }
        });
    },

    /* ---{ Get response through fetch method, not from cache and does not cache the response itself }--- */
    Fetch: function (bearerToken, apiUrl) {
        return new Promise(async (resolve, reject) => {
            let headers = new Headers();

            headers.set("Authorization", `Bearer ${bearerToken}`);

            //catch when api's are down
            let response = await fetch(apiUrl, { headers }).catch(error => console.log(error.message));
            if(!response) {
                response = {
                    "ok": false,
                    "status": 503,
                    "statusText": "Service Unavailable",
                    "url": apiUrl
                }
                reject(response);
            }
            else if (response.status === 400){
                reject(response);
            } else if (!(response.status >= 200 && response.status < 500)) {
                reject(`Request to [...] failed - ${response.status}: ${response.statusText}`);
            } else {
                resolve(response);
            }
        });
    }
};

/* ---{ Resolve the response's data type into the given dataType }--- */
function resolveDataType(response, dataType) {
    return new Promise(async (resolve, reject) => {
        if (response.status >= 200 && response.status < 500) {
            try {
                switch (dataType) {
                    case "text":
                        resolve(await response.text());
                        break;
                    case "json":
                        resolve(await response.json());
                        break;
                    case "blob":
                        resolve(await response.blob());
                        break;
                    default:
                        resolve();
                }
                reject(`"${dataType}" is not a supported data type.`);
            } catch (error) {
                reject(response);
            }
        } else {
            reject(response);
        }

        if(response.ok === false){
            let toastText = (
                <p className="toast-content-encompass">
                    {response.url} status: {response.statusText}
                </p>
            );
            toast.error(toastText, { autoClose: false, draggable: false, pauseOnFocusLoss: false });
        }
    });
}

function getData(bearerToken, apiUrl, dataType, useCache, cacheExpirationHours = 1) {
    return new Promise(async (resolve, reject) => {
        let response,
            data;

        if (useCache) {
            try {
                response = await getResponseFrom.Cache(bearerToken, apiUrl, cacheExpirationHours);
                data = await resolveDataType(response, dataType);
            } catch (e) {
                reject(e);
            }
        } else {
            try {
                response = await getResponseFrom.Fetch(bearerToken, apiUrl);
                data = await resolveDataType(response, dataType);
            } catch (e) {
                reject(e);
            }
        }
        resolve(data);
    });
}

export default getData;